import {
  gitBranchOutline,
  chatbubbleEllipsesOutline,
  copyOutline,
  flashOutline,
  libraryOutline,
  musicalNotesOutline,
  pricetagOutline,
  swapHorizontalOutline,
} from 'ionicons/icons';
import type { AutomationActionType } from '../../types/AutomationWorkflow.types';

export const getAutomationBlockIcon = (
  type: AutomationActionType | 'trigger',
) => {
  switch (type) {
    case 'trigger':
      return flashOutline;
    case 'import_to_library':
      return libraryOutline;
    case 'read_write_tags':
      return pricetagOutline;
    case 'add_to_serato_crate':
      return musicalNotesOutline;
    case 'copy_move_file':
      return swapHorizontalOutline;
    case 'run_agent':
      return chatbubbleEllipsesOutline;
    case 'if_else':
      return gitBranchOutline;
    default:
      return copyOutline;
  }
};
